import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CustomerPartNumberModel } from "@tCooneyBrothers/ApiModels";
import CustomerPartNumberState from "@tCooneyBrothers/Store/Data/CustomerPartNumber/CustomerPartNumberState";
import { Draft } from "immer";

const initialState: CustomerPartNumberState = {
    isLoading: false,
    value: [],
};

const reducer = {
    "Data/CustomerPartNumber/BeginLoadCustomerPartNumber": (draft: Draft<CustomerPartNumberState>) => {
        draft = {
            isLoading: true,
        };
    },
    "Data/CustomerPartNumber/CompleteLoadCustomerPartNumbers": (
        draft: Draft<CustomerPartNumberState>,
        payload: { action: CustomerPartNumberModel[] },
    ) => {
        draft.value = payload.action;
    },
    "Data/CustomerPartNumber/Add": (
        draft: Draft<CustomerPartNumberState>,
        payload: { action: CustomerPartNumberModel },
    ) => {
        draft.value?.push(payload.action);
    },
    "Data/CustomerPartNumber/Delete": (
        draft: Draft<CustomerPartNumberState>,
        payload: { action: CustomerPartNumberModel[] },
    ) => {
        if (payload.action) {
            draft.value = payload.action;
        } else {
            draft.value = [];
        }
        // draft.value?.pop();
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
